import { render, staticRenderFns } from "./previewDialog.vue?vue&type=template&id=fb21a168&scoped=true"
import script from "./previewDialog.vue?vue&type=script&lang=js"
export * from "./previewDialog.vue?vue&type=script&lang=js"
import style0 from "./previewDialog.vue?vue&type=style&index=0&id=fb21a168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb21a168",
  null
  
)

export default component.exports